import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SideNavEmitService } from '../../services/side-nav-emit.service';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { Subscription } from 'rxjs';
import { GlobalAppTabsComponent } from 'src/app/components/global-apps/global-app-tabs/global-app-tabs.component';
import { ApprovalNotificationtabComponent } from '../ess/leaves/approval-notificationtab/approval-notificationtab.component';
import { ExpenseTabComponent } from 'src/app/components/global-apps/expense-tab/expense-tab.component';
import { DropDownComponent } from 'src/app/components/drop-down/drop-down.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Constants } from 'src/app/models/Constants';
import { GlobalValuesService } from 'src/app/services/global-values.service';
import { AlertService } from 'src/app/services/alert.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators  } from '@angular/forms';
import { DataTableComponent } from 'src/app/components/data-table/data-table.component';
import { FusionButtonComponent } from 'src/app/components/fusion-button/fusion-button.component';

@Component({
  selector: 'app-approvals',
  standalone: true,
  imports: [CommonModule,PageHeaderComponent,NgSelectModule,GlobalAppTabsComponent,ApprovalNotificationtabComponent, ExpenseTabComponent, DropDownComponent,  DataTableComponent, FusionButtonComponent, ReactiveFormsModule],
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.css']
})
export class ApprovalsComponent implements OnInit {
  //sideNavsubscription: Subscription; /* hiden temporarily as we have modified the nav tab functionalities and also have made few changes to retain the page on reload */
  approvalsTabToShow= 'details';
  pageComponentName = 'Approvals';

  option=['Leaves', 'Expense'];
  staticOption=['Leaves', 'Expense'];
  eventValue = 'Leaves';
  activeNav:any;
  dynamicDefaultTab: any;
  approvalnotification: any;
  historyData:Array<any> = [];
  inProgressTab = true; 
  successMsg = Constants.SUCCESS_MESSAGE;
  deletedMsg = Constants.DELETE_SUCCESS_MESSAGE;
  approveMsg = Constants.APPROVE_MESSAGE;
  rejectMsg = Constants.REJECT_MESSAGE;
  errorMessage = '';
  companyId = this.globalValues.orgId;
  rejectionform!: FormGroup;
  checkedEmployees: Array<any> = [];
  downloadCurrentDisable: boolean | undefined;
  activeDropDownComp:any;
  approvalActiveTable: any;
  historyActiveTable: any;
  dropdownObj: any;
  isStatic = true
  approvalType:string = "";
  
  constructor( private errorHandler : ErrorHandlerService, private formBuilder: FormBuilder, private alertService: AlertService, private globalValues: GlobalValuesService, private datePipe: DatePipe,private apiService: ApiService,private sideNavItem: SideNavEmitService,private activatedRouteApprovals: ActivatedRoute, private router: Router) {
    //  this.sideNavsubscription = this.sideNavItem.clickedSideNav$.subscribe(navItem => this.approvalsTabToShow = navItem); /* hiden temporarily as we have modified the nav tab functionalities and also have made few changes to retain the page on reload */
    this.rejectionform = this.formBuilder.group({
      rejectReason: ["", Validators.required],
      empId: "",
      _id: "",
      type: ""
    });
    // SKS21NOV24 Retrieve user data from local storage and set the default tab dynamically based on the 'approvals' module.
    const userDataConst:any = localStorage.getItem('userData');
    if(userDataConst) {
      const loggedInUserData = JSON.parse(userDataConst).apps;
      loggedInUserData.forEach((appArr:any) => {
        if(appArr.name === 'hrm'){
          appArr.modules.forEach((modArr:any) => {
            if(modArr.name === 'approvals'){
              modArr.tabs.forEach((tab:any) =>{
                if(tab.name === "approvals"){
                  this.dynamicDefaultTab = tab;
                  let approvalType:any;
                  // SK03DEC24 routing based on dropdown click
                  this.activatedRouteApprovals.queryParams.subscribe((params:any) => {
                    this.approvalType, approvalType = params['approvalType'];
                    this.activeNav = params['activeNav'];
                    if(this.activeNav === "approvals")this.emittedValue({data:approvalType || 'Leaves'}, "TS");
                  });
                }
              })
            }
          });
        }
      });
    } else {
      console.log('waiting for the api response');
    }
    // SKS21NOV24: Process the default tab's components and populate dropdown options if the default tab exists.
    if(this.dynamicDefaultTab){
      this.dynamicDefaultTab.components.forEach((comp:any) => {
        if(comp.type === 'dropdown'){
          this.dropdownObj=comp.values
          let options=['Leaves', 'Expense'];
          comp.values.map((item: { name: string; }) => options.push(item.name));
          let opts = new Set(options);
          this.option = Array.from(opts)
          // this.eventValue = this.option[0]
        }
      });
    }
  }

  ngOnInit(): void {
    /* hiden temporarily as we have modified the nav tab functionalities and also have made few changes to retain the page on reload */
    // this.route.queryParams.subscribe(params => { 
    //   this.approvalsTabToShow = params['activeNav'] || 'details';
    // });
    // SK07MAR24 adding approvalType as query params to route the page on notification click
       
  }

  // SKS21NOV24 Handle emitted value and dynamically update components and routing based on the event.
  emittedValue(event:any, from:any){
    this.eventValue=event.data;  
    if(this.staticOption.includes(event.data)){
      this.isStatic = true
    }else{
      this.isStatic = false
    }
    this.activeDropDownComp = []
    //SKS21NOV24 Populate active dropdown components based on the selected value.
    this.dynamicDefaultTab?.components.forEach((comp:any) => {
      if(comp.selectName === event.data){
        this.activeDropDownComp.push(comp);
      }
    })
     //SKS21NOV24 Identify active tables for approval and history.
    this.activeDropDownComp.forEach((data: any) => {
      if(data.type === "table" && data.name === "approval"){
        this.approvalActiveTable = data
      }
      if(data.type === "table" && data.name === "history"){
        this.historyActiveTable = data
      }
    })
    if(event.data != "Leaves" && event.data != "Expense" ){
      this.resetForm("inProgress")
    }
    
      // this.historyTab()
      // this.approvals()
     //SKS21NOV24 If no active dropdown components, update the URL with query parameters.
    // if(this.activeDropDownComp.length === 0){
      if(from === "UI")this.router.navigate([], { queryParams: { activeNav: "approvals", approvalType: event.data } });
    // }
  }
  resetForm(type:any){
    if(type === "inProgress"){
      this.approvals();
    } else if(type === "history"){
      this.historyTab();
    }
    this.historyData = [];
    this.approvalnotification=[];
  }
  // SKS21NOV24 Fetch approval notifications based on the selected dropdown type and approval status.
  approvals(): void {
    const item = this.dropdownObj?.find((obj: { name: string; value: string }) => obj?.name === this.eventValue);
    if(item){
      const ep = this.approvalActiveTable?.config?.endpoint
      const params = new HttpParams({
        'fromObject':{
          "type" : item.value ,
          "status":this.approvalActiveTable.approvalsVal
        }
      });
      // SK03DEC24 configurations changes to get the endpoint data directly
      if(this.approvalType !== "Leaves" && this.approvalType !== "Expense" ){
        this.apiService.fetchValue(ep).subscribe((data: any) => {
          this.approvalnotification = data;
        })
      }
    }
  }
  // SKS21NOV24 Fetch history data based on the selected dropdown type and history status.
  historyTab() {
    const item = this.dropdownObj.find((obj: { name: string; value: string }) => obj.name === this.eventValue);
    if(item){
      const ep = this.historyActiveTable?.config?.endpoint
      const params = new HttpParams({
        'fromObject':{
          "type" : item?.value, 
          "status": this.historyActiveTable?.historyVal
        }
      });
      // SK03DEC24 configurations changes to get the endpoint data directly
      if(this.approvalType !== "Leaves" && this.approvalType !== "Expense" ){
        this.apiService.fetchValue(ep).subscribe((data: any) => {
          this.historyData = data;
        })
      }
    }
  }
  // SKS21NOV24 Approve an item, update history and notifications, and log the action.
  onApprove(data:{empId:string,id:string}){
    console.log(data)
    const item = this.dropdownObj.find((obj: { name: string; value: string }) => obj.name === this.eventValue);
    const time = new Date().toLocaleString("en-AU");
    const status = "Approved";
    const approvalData = {type:item.value, employeeId:data.empId, _id:data.id, time:time, status:status, 'companyId' : this.companyId};
    this.apiService.writeValue('patch',this.approvalActiveTable.config.endpoint+"?type="+item.value,approvalData)
    .subscribe({
      next: (data:any) => {
        console.log(data)
        this.historyData = []
        this.approvalnotification = []
        this.approvals();
        this.saveSuccess(data.message)
        this.globalValues.employeeDataGet();
      },
      error: (err: HttpErrorResponse) => {
        this.showError(err);
      }
    });
 }
 // SKS21NOV24 Display a success message and reset the error message.
 saveSuccess(data:any) {
  this.alertService.messageOnPass('success', data);
  this.ngOnInit();
  this.errorMessage = '';
 }
// SKS21NOV24 Handle errors and display an error message.
  showError(err:any){
    this.errorHandler.handleError(err);
    this.errorMessage = this.errorHandler.errorMessage;
    this.alertService.messageOnPass('error', this.errorMessage);
  }
  // SKS21NOV24 Initialize rejection form with the selected item details.
  onreject(data:{empId:string,id:string}){
    const item = this.dropdownObj.find((obj: { name: string; value: string }) => obj.name === this.eventValue);
    this.rejectionform.setValue({
      rejectReason: "",
      empId: data.empId,
      _id: data.id,
      type:item.value
    })
  }
  //SKS21NOV24 after clicking reject button, the stored data in form will be sent to api
  reasonText(){
    const item = this.dropdownObj.find((obj: { name: string; value: string }) => obj.name === this.eventValue);
    const value = this.rejectionform.value;
    const time = new Date().toLocaleString("en-AU");
    const status = "Rejected";
    const rejectedData = {type:value.type, employeeId:value.empId, _id:value._id, rejectionReason:value.rejectReason, time:time, status: status, 'companyId' : this.companyId};
    this.apiService.writeValue('patch',this.approvalActiveTable.config.endpoint+"?type="+item.value,rejectedData)
    .subscribe({
      next: (rejectData) => {
        this.saveSuccess(this.rejectMsg);
        this.historyData = []
        this.approvalnotification = []
        this.historyTab();
        this.globalValues.employeeDataGet();
      },
      error: (err: HttpErrorResponse) => {
        this.showError(err);
      }
    });
  }
// SKS21NOV24 Update the list of checked employees and toggle the download button state.
  tableCheckedDataa(checkedArray:any){
    this.checkedEmployees = [];
    this.checkedEmployees = checkedArray;
    if(this.checkedEmployees.length === 0){
      this.downloadCurrentDisable = true;
    } else {
      this.downloadCurrentDisable = false;
    }
  }
}

